export default store => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case 'userAdmin/setAdminToken':
        const token = state.userAdmin.token || ''
        if (process.client) {
          if (token) {
            global.$cookies.set('admin-token', token)
          } else {
            global.$cookies.remove('admin-token')
          }
        }
        break
      case 'userAdmin/setAdmin':
        if (process.client) {
          const adminStore = require('theme/store/lib/storage').userAdminStore
          adminStore.setItem('currentAdmin', state.userAdmin.current)
        }
        break
      case 'userAdmin/setAdminRole':
        if (process.client) {
          let userAdminRole = state.userAdmin.role
          global.$cookies.set('admin-role', userAdminRole)
        }
        break
      case 'userAdmin/setStoreCode':
        const storeCode = state.userAdmin.storeCode || ''
        if (process.client) {
          if (storeCode) {
            global.$cookies.set('store-code', storeCode)
          } else {
            global.$cookies.remove('store-code')
          }
        }
        break
      case 'userAdmin/setStoreId':
        const storeId = state.userAdmin.storeId || ''
        if (process.client) {
          if (storeId) {
            global.$cookies.set('store-id', storeId)
          } else {
            global.$cookies.remove('store-id')
          }
        }
        break
      case 'userAdmin/setUserType':
        const userType = state.userAdmin.userType || 'seller'
        if (process.client) {
          global.$cookies.set('user-type', userType)
        }
        break
      case 'userAdmin/setUserStoreId':
        const userStoreId = state.userAdmin.userStoreId || ''
        if (process.client) {
          if (userStoreId) {
            global.$cookies.set('user-store-id', userStoreId)
          } else {
            global.$cookies.remove('userstore-id')
          }
        }
        break
      case 'userAdmin/setOnlineStoreCode':
        const onlineStoreCode = state.userAdmin.onlineStoreCode || ''
        if (process.client) {
          if (onlineStoreCode) {
            global.$cookies.set('online-store-code', onlineStoreCode)
          } else {
            global.$cookies.remove('online-store-code')
          }
        }
        break
      case 'userAdmin/setCoupons':
        const coupons = state.userAdmin.coupons || []
        if (process.client) {
          const adminStore = require('theme/store/lib/storage').userAdminStore
          adminStore.setItem('coupons', coupons)
        }
        break
    }
  })
}
